import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';

@Module({ dynamic: true, name: 'loadingStore', store })
export class LoadingStore extends VuexModule {
  private showPersisted = false;

  @Mutation
  show() {
    this.showPersisted = true;
  }

  @Mutation
  hide() {
    this.showPersisted = false;
  }

  get isShow() {
    return this.showPersisted;
  }
}

const LoadingService = (() => getModule(LoadingStore))();

export default LoadingService;
export { LoadingService as VbLoadingService };
